<template>
  <div style="padding: 20px;" v-if="userinfo.isAdmin == true">
    <a href="/admin">Admin home</a> | 
    <a href="/adminpages">Pages</a> | 
    <a href="/adminorders">Orders</a>
    <table>
      <thead>
        <th>
          Pageid/WebsiteId
        </th>
        <th>
          Pagetitle/pageslug
        </th>
        <th>
          Belongsto
        </th>
        <th>
          pagetype
        </th>
        <th>
          blockstyle
        </th>
        <th>
          blockalign
        </th>
        <th>
          Remove
        </th>
      </thead>
      <tbody>
        <tr v-for="page in pages">
          <td>
            {{page._id}} <br />
            {{page.websiteid}}
          </td>
          <td>
            {{page.pagetitle}}<br />
            {{page.pageslug}}
          </td>
          <td>
            {{page.belongsto}}
          </td>
          <td>
            {{page.pagetype}}
          </td>
          <td>
            {{page.blockstyle}}
          </td>
          <td>
            {{page.blockalign}}
          </td>
          <td>
            <button @click.prevent="removePage(page._id, page.websiteid)">Remove page</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import MainNav from '../components/navigation/MainNav.vue';
  import HomeBlock from '../components/content/HomeBlock.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        username: '',
        password: '',
        submitted: false,
        loading: false,
        loggingin: false,
        returnUrl: '',
        error: '',
        users: {},
        pages: {},
        userinfo: JSON.parse(localStorage.getItem('user'))
      }
    },
    created () {
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      MainNav,
      HomeBlock
    },
    methods: {
        getAllPages(){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/pages/', requestOptions)
            .then(response => {
                this.pages = response.data.response
            })
        },
        getPagesBySite(websiteid){
            const requestOptions = {
              headers: authHeader()
            }

            axios.get(process.env.VUE_APP_ROOT_API+'/pages/'+websiteid, requestOptions)
            .then(response => {
                this.pages = response.data.response
            })
        },
        removePage(id, websiteid){
            const requestOptions = {
              headers: authHeader()
            }

            axios.delete(process.env.VUE_APP_ROOT_API+'/pages/'+websiteid+'/'+id, requestOptions)
            .then(response => {
                console.log(response)
                this.showModal = false
            })
        }
    },
    mounted(){
      if(this.$route.params.websiteid){
        this.getPagesBySite(this.$route.params.websiteid)
      } else {
        this.getAllPages()
      }
    }
  }
</script>

<style lang="scss" scoped>
  table{
    border-collapse: collapse;

    th, td{
      padding: 10px 20px;
      border: 1px solid #ccc;
    }

    th{
      color: #666;
      text-transform: uppercase;
      font-weight: normal;
      font-size: .8rem;
    }
  }
</style>
